/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";
import { TOGGLE_BUTTON_GROUP_CLASS, TOGGLE_BUTTON_CLASS } from "../../../shared/controls/DimToggle";

export const SINGLE_SELECT_CLASS = "SingleSelect";

export const styles = (theme: Theme) =>
  createStyles({
    popperContent: {
      width: 323,
      padding: theme.spacing(1, 4, 2, 4),
    },
    buttonContainer: {
      display: "flex",
      flexDirection: "row", 
      justifyContent: "space-between",
      paddingTop: theme.spacing(),
    },
    selectButtonContainer: {
      marginTop: theme.spacing(),
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      minWidth: theme.spacing(2),
    },
    applyButtonContainer: {
      marginTop: theme.spacing(),
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      [`&.${SINGLE_SELECT_CLASS}`]: {
        justifyContent: "center",
        width: "100%",
      },
    },
    periodSelector: {
      width: "100%",
      border: "none",
      padding: theme.spacing(2, 0),
      borderTop: `1px solid ${theme.palette.grey[400]}`,
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
      [`&.${TOGGLE_BUTTON_GROUP_CLASS}`]: {
        borderRadius: 0,
      },
    },
    button: {
      [`&.${TOGGLE_BUTTON_CLASS}`]: {
        borderRadius: 3,
      },
    },
    lastButtonFirst: {
      [`&.${TOGGLE_BUTTON_GROUP_CLASS} .${TOGGLE_BUTTON_CLASS}:last-child`]: {
        marginRight: "calc(75% + 1px)",
      },
    },
    lastButtonSecond: {
      [`&.${TOGGLE_BUTTON_GROUP_CLASS} .${TOGGLE_BUTTON_CLASS}:last-child`]: {
        marginRight: "calc(50% + 1px)",
      },
    },
    lastButtonThird: {
      [`&.${TOGGLE_BUTTON_GROUP_CLASS} .${TOGGLE_BUTTON_CLASS}:last-child`]: {
        marginRight: "calc(25% + 1px)",
      },
    },
    buttonActive: {
      fontWeight: 'bold',
    },
    applyCancelButton: {
      textTransform: 'none',
      marginLeft: theme.spacing() / 2,
      "&.Mui-disabled": {
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.action.disabled,
      },
    },
    root: {
      margin: theme.spacing(0.5, 0, 0, 0),
      width: "100%"
    },
    selectButton: {
      minWidth: theme.spacing(4),
      marginRight: theme.spacing() / 2,
      "&.Mui-disabled svg > path": {
        fill: theme.palette.action.disabled,
      },
    },
    selectButtonLabel: {
      fontSize: 14,
    },
    selectButtonIcon: {
      width: 15,
      height: 15,
    },
  });

export default styles;
export const useStyles = makeStyles(styles);
